import { gql } from 'graphql.macro'
import RuleFragment from '../../lib/RuleFragment'

export default gql`
  mutation CreateRule($data: RuleDataInput!) {
    createRule(data: $data) {
      ...RuleFragment
    }
  }

  ${RuleFragment}
`
